import './nav.scss';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('[data-scroll-class]');
  const wrapper = document.querySelector('[data-nav-wrapper]');
  const scrollable = document.querySelector('[data-nav-scrollable]');
  const hamburger = document.querySelector('[data-hamburger]');
  wrapper.classList.add('nav_loaded');

  function close() {
    wrapper.classList.remove('nav_opened');
    hamburger.classList.remove('hamburger_opened');
    targets[0].classList.remove('nav_opened');
    enableBodyScroll(scrollable);
  }

  hamburger.addEventListener('click', () => {
    if (wrapper.classList.contains('nav_opened')) {
      close();
    } else {
      wrapper.classList.add('nav_opened');
      targets[0].classList.add('nav_opened');
      hamburger.classList.add('hamburger_opened');
      disableBodyScroll(scrollable);
    }
  });

  document.addEventListener('click', (e) => {
    if (!wrapper.contains(e.target) && !hamburger.contains(e.target)) {
      close();
    }
  });

  document.addEventListener('keydown', (e) => {
    switch (e.keyCode) {
      case 27:
        close();
        break;
      default: //
    }
  });
});
